import {
    TLAHardewareInterfaceGstDecklinkModesType,
    TLAHardewareInterfaceGstDecklinkProfileIdType,
    TLAHardewareInterfaceGstDecklinkVideoFormatType,
    TLAHardwareInterfaceDecklinkConnectionType,
} from "../../__generated__/globalTypes";

export const decklinkConnections: Record<TLAHardwareInterfaceDecklinkConnectionType, string> = {
    Auto: "auto",
    Component: "component",
    Composite: "composite",
    HDMI: "hdmi",
    OpticalSDI: "optical-sdi",
    SDI: "sdi",
    SVideo: "svideo",
};

export function getDecklinkConnections(): { key: TLAHardwareInterfaceDecklinkConnectionType; value: string }[] {
    return Object.keys(decklinkConnections).map((key) => ({
        key: key as TLAHardwareInterfaceDecklinkConnectionType,
        value: decklinkConnections[key as TLAHardwareInterfaceDecklinkConnectionType],
    }));
}

export const decklinkGstModes: Record<TLAHardewareInterfaceGstDecklinkModesType, string> = {
    Auto: "auto",
    NTSC: "ntsc",
    NTSC2398: "ntsc2398",
    PAL: "pal",
    NTSCP: "ntsc-p",
    PALP: "pal-p",
    HD1080P2398: "1080p2398",
    HD1080P24: "1080p24",
    HD1080P25: "1080p25",
    HD1080P2997: "1080p2997",
    HD1080P30: "1080p30",
    HD1080I50: "1080i50",
    HD1080I5994: "1080i5994",
    HD1080I60: "1080i60",
    HD1080P50: "1080p50",
    HD1080P5994: "1080p5994",
    HD1080P60: "1080p60",
    HD720P50: "720p50",
    HD720P5994: "720p5994",
    HD720P60: "720p60",
    TwoK2398: "1556p2398",
    TwoK24: "1556p24",
    TwoK25: "1556p25",
    TwoKDCIP2398: "2kdcip2398",
    TwoKDCIP24: "2kdcip24",
    TwoKDCIP25: "2kdcip25",
    TwoKDCIP2997: "2kdcip2997",
    TwoKDCIP30: "2kdcip30",
    TwoKDCIP50: "2kdcip50",
    TwoKDCIP5994: "2kdcip5994",
    TwoKDCIP60: "2kdcip60",
    FourK2398: "2160p2398",
    FourK24: "2160p24",
    FourK25: "2160p25",
    FourK2997: "2160p2997",
    FourK30: "2160p30",
    FourK50: "2160p50",
    FourK5994: "2160p5994",
    FourK60: "2160p60",
    NTSCWidescreen: "ntsc-widescreen",
    NTSC2398Widescreen: "ntsc2398-widescreen",
    PALWidescreen: "pal-widescreen",
    NTSCPWidescreen: "ntsc-p-widescreen",
    PALPWidescreen: "pal-p-widescreen",
    FourKDCIP2398: "4kdcip2398",
    FourKDCIP24: "4kdcip24",
    FourKDCIP25: "4kdcip25",
    FourKDCIP2997: "4kdcip2997",
    FourKDCIP30: "4kdcip30",
    FourKDCIP50: "4kdcip50",
    FourKDCIP5994: "4kdcip5994",
    FourKDCIP60: "4kdcip60",
    EightK2398: "8kp2398",
    EightK24: "8kp24",
    EightK25: "8kp25",
    EightK2997: "8kp2997",
    EightK30: "8kp30",
    EightK50: "8kp50",
    EightK5994: "8kp5994",
    EightK60: "8kp60",
    EightKDCIP2398: "8kdcip2398",
    EightKDCIP24: "8kdcip24",
    EightKDCIP25: "8kdcip25",
    EightKDCIP2997: "8kdcip2997",
    EightKDCIP30: "8kdcip30",
    EightKDCIP50: "8kdcip50",
    EightKDCIP5994: "8kdcip5994",
    EightKDCIP60: "8kdcip60",
};

export function getDecklinkModes(): { key: TLAHardewareInterfaceGstDecklinkModesType; value: string }[] {
    return Object.keys(decklinkGstModes).map((key) => ({
        key: key as TLAHardewareInterfaceGstDecklinkModesType,
        value: decklinkGstModes[key as TLAHardewareInterfaceGstDecklinkModesType],
    }));
}

export const decklinkProfileIds: Record<TLAHardewareInterfaceGstDecklinkProfileIdType, string> = {
    Default: "default",
    OneSubDeviceFull: "one-sub-device-full",
    OneSubDeviceHalf: "one-sub-device-half",
    TwoSubDevicesFull: "two-sub-devices-full",
    TwoSubDevicesHalf: "two-sub-devices-half",
    FourSubDevicesHalf: "four-sub-devices-half",
};

export function getDecklinkProfiles(): { key: TLAHardewareInterfaceGstDecklinkProfileIdType; value: string }[] {
    return Object.keys(decklinkProfileIds).map((key) => ({
        key: key as TLAHardewareInterfaceGstDecklinkProfileIdType,
        value: decklinkProfileIds[key as TLAHardewareInterfaceGstDecklinkProfileIdType],
    }));
}

export const decklinkVideoFormats: Record<TLAHardewareInterfaceGstDecklinkVideoFormatType, string> = {
    Auto: "auto",
    EightBitYUV: "8bit-yuv",
    TenBitYUV: "10bit-yuv",
    EightBitARGB: "8bit-argb",
    EightBitBGRA: "8bit-bgra",
    TenBitRGB: "10bit-rgb",
};

export function getDecklinkVideoFormats(): {
    key: TLAHardewareInterfaceGstDecklinkVideoFormatType;
    value: string;
}[] {
    return Object.keys(decklinkVideoFormats).map((key) => ({
        key: key as TLAHardewareInterfaceGstDecklinkVideoFormatType,
        value: decklinkVideoFormats[key as TLAHardewareInterfaceGstDecklinkVideoFormatType],
    }));
}
